import React, { useEffect, useState } from "react";
import { MotifCheckbox, MotifButton, MotifIcon, MotifMenu } from "@ey-xd/motif-react";
import { deleteIcon, IconoirCheckIcon, IconoirFilterList, IconoirSort, uploadIcon } from "../../common/MotifIcons";
import { apiQueryWithToken } from "../../common/services/apiBaseUrlConfig";
import SmallCircleLoader from "./SmallCircleLoader";
import SortUpDark from '../../common/images/sort-up-dark.svg';
import SortDownDark from '../../common/images/sort-down-dark.svg';
import SortUpLight from '../../common/images/sort-up-light.svg';
import SortDownLight from '../../common/images/sort-down-light.svg';
import { getDateTimeFormat, getUploadedByFormat,getImagePath,getFileTypeName } from "../../common/utility/utility";


import "./FailedUploadsList.scss";
import logger from "../../common/utils/logger";

export const FailedUploadsList = ({
  failedUploadData,
  setFailedUploadLoadData,
  failedUploads,
  isFailedUploadLoadData,
  showProgressBar,
  selectedFileIds,
  onToggleSelect,
  onToggleSelectAll,
  uploadingFileId,
  uploadingFileIds,
  onDelete,
  onReupload,
  onBulkDelete,
  onBulkReupload,
  showUploadData,
  showTopRow,
  disableCloseButton,
  variant = "",
  failedDeleteLoading,
  setFailedDeleteLoading,
  processingMsg
}) => {

  const [afterDeleteLoadData, setAfterDeleteLoadData] = useState(null);
  const [currentDeleteLoading, setCurrentDeleteLoading] = useState(false);
  const [currentDeleteTimer, setCurrentDeleteTimer] = useState(null);
  const [reuploadAttempts, setReuploadAttempts] = useState({});
  const [selectedFileIdData, setSelectedFileIdData] = useState([]); // for previous session
  const [previousSessionData, setPreviousSessionData] = useState([]);
  const [calculated, setCalculated] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [allfilesDeleted, setAllfilesDeleted] = useState(false);
  const latestFaileduploadData = failedUploadData.map((file) => file.engagementIdGUID);
  const isFromFailedUploads = failedUploads?.length > 0;
  const [deleteLoad, setDeleteLoad] = useState(null);
  const [currentSessionFilterOpen, setCurrentSessionFilterOpen] = useState(false);
  const [previousSessionFilterOpen, setPreviousSessionFilterOpen] = useState(false);
  const [selectedUploader, setSelectedUploader] = useState(null);
  const [onClickAtoZ, setOnClickAtoZ] = useState(false);
  const [onClickZtoA, setOnClickZtoA] = useState(false);
  const [onClickNewest, setOnClickNewest] = useState(false);
  const [onClickOldest, setOnClickOldest] = useState(false);

  const dataReceived =

    afterDeleteLoadData !== null
      ? afterDeleteLoadData
      : isFromFailedUploads
        ? failedUploads || []
        : showUploadData
          ? failedUploadData || []
          : [];

  const isDeleteInProgress =
    deleteLoad !== null ||
    currentDeleteLoading ||
    failedDeleteLoading;

  const isReuploadInProgress =
    (uploadingFileId !== null && uploadingFileId !== undefined) ||
    (Array.isArray(uploadingFileIds) && uploadingFileIds.length > 0);

  const isAnyActionInProgress = isReuploadInProgress || isDeleteInProgress;

  // Self-heal: if the parent reports no delete is running, clear any stale
  // local delete flags so the toolbar / checkboxes don't stay disabled.
  useEffect(() => {
    if (!failedDeleteLoading) {
      if (deleteLoad !== null) setDeleteLoad(null);
      if (currentDeleteLoading) setCurrentDeleteLoading(false);
    }
  }, [failedDeleteLoading]);


  useEffect(() => {
    if (showUploadData) {
      const latestFailedUploadData = failedUploadData
        .map((file) => file.engagementIdGUID)
        .filter(Boolean);

      if (latestFailedUploadData.length > 0) {
        GetErrorsByEngagement(latestFailedUploadData[0]);
      }
    }
  }, [showUploadData, failedUploadData.length > 0]);

  const handleDeleteAllAPI = async () => {
    setFailedDeleteLoading(true);
    if (selectedFileIdData.length === 0) {
      setFailedDeleteLoading(false);
      setDeleteLoad(null);
      return;
    }

    try {
      const promises= selectedFileIdData.map(async (errorId) => {
        const file = (afterDeleteLoadData || failedUploadData || []).find(
          (f) => f.errorId === errorId
        );
        if (file) {
          await deleteErrorLog(
            file.engagementIdGUID,
            selectedFileIdData,
            file.uploadedBy,
            file.transactionID
          ).then(() => {
           
          });
        }
      });
      await Promise.all(promises);
      setFailedDeleteLoading(false);
      setSelectedFileIdData([]);
      setSelectedUploader([]);
    } catch (err) {
      setFailedDeleteLoading(false);
      logger.error("Failed to delete all selected files:", err);
    } finally {
      setDeleteLoad(null);
    }
  };

  const GetErrorsByEngagement = async (engagementId_GUID) => {
    try {
      const response = await apiQueryWithToken.post(
        `api/errors/engagement?engagementIdGUID=${engagementId_GUID}`
      );
      setCalculated(false);
      const responseData = response.data || [];
      setAfterDeleteLoadData(responseData);

      setPreviousSessionData(responseData);


      if (!responseData.length > 0) {
        setAllfilesDeleted(true);
        setFailedUploadLoadData(true);
      }
      return responseData;
    } catch (error) {
      logger.error("Error fetching engagement errors:", error);
    }
  };

  const handleReuploadClick = (fileId) => {
    const currentAttempts = reuploadAttempts[fileId] || 0;
    if (currentAttempts < 3) {
      onReupload(fileId);
      setReuploadAttempts((prev) => ({
        ...prev,
        [fileId]: currentAttempts + 1,
      }));
    }
  };

  const onToggleSelectData = (fileId) => {
    setSelectedFileIdData((prev) => {
      const newSelection = prev.includes(fileId)
        ? prev.filter((id) => id !== fileId)
        : [...prev, fileId];
      setSelectedIds(newSelection);
      return newSelection;
    });
  };
// const failedUploadIds = (failedUploads || []).map(f => f.batchStatus === "Processing" ? f.transactionID : f.id);
  const onToggleSelectAllData = (displayedData = []) => {
    const allIds = (displayedData || [])
      .map(file => file.errorId)
      .filter(Boolean);
    // If every displayed row is already selected, deselect all; otherwise select all.
    setSelectedFileIdData((prev) => {
      const allSelected = allIds.length > 0 && allIds.every(id => prev.includes(id));
      return allSelected ? [] : allIds;
    });
  };

  const deleteErrorLog = async (
    engagementId_GUID,
    errorId,
    emailAddress,
    transactionID
  ) => {
    setFailedDeleteLoading(true);
    try {
      const cleanederrorID = errorId.filter(item => item !== null);
      const response = await apiQueryWithToken.delete(`api/errors/delete`, {
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          engagementIdGUID: engagementId_GUID,
          errorIds: cleanederrorID,
          emailAddress: emailAddress,
          TransactionID: transactionID,
        },
      });
      GetErrorsByEngagement(engagementId_GUID);
      return response.data;
    } catch (error) {
      throw error;
    } finally {
      setFailedDeleteLoading(false);
    }
  };
const handleCurrentSessionClose = () => {
  setCurrentSessionFilterOpen(false);
  setOnClickAtoZ(false);
  setOnClickZtoA(false);
  setOnClickNewest(false);
  setOnClickOldest(false);
};

const handlePreviousSessionClose = () => {
  setPreviousSessionFilterOpen(false);
  setOnClickAtoZ(false);
  setOnClickZtoA(false);
  setOnClickNewest(false);
  setOnClickOldest(false);
};
  const handleToggleSelectAllUploaders = (selectedUploader) => {
    const allUploaders = Array.from(new Set(((afterDeleteLoadData || failedUploadData || []).filter(file => {
                                                      // Exclude files whose transactionID matches any id in failedUploads
                                                      const failedUploadIds = (failedUploads || []).map(f => f.batchStatus === "Processing" ? f.transactionID : f.id);
                                                      return !failedUploadIds.includes(file.transactionID);
                                                    })).map(file => file.uploadedBy)));
    if (Array.isArray(selectedUploader) && selectedUploader.length === allUploaders.length) {
      // All are selected, so deselect all
      setSelectedUploader([]);
      setPreviousSessionData((afterDeleteLoadData || failedUploadData || [])
    .filter(file => {
                                                      // Exclude files whose transactionID matches any id in failedUploads
                                                      const failedUploadIds = (failedUploads || []).map(f => f.batchStatus === "Processing" ? f.transactionID : f.id);
                                                      return !failedUploadIds.includes(file.transactionID);
                                                    }));
    } else {
      // Select all
      setSelectedUploader(allUploaders);
      const filtered = (afterDeleteLoadData || failedUploadData || [])
      .filter(file => {
                                                      // Exclude files whose transactionID matches any id in failedUploads
                                                      const failedUploadIds = (failedUploads || []).map(f => f.batchStatus === "Processing" ? f.transactionID : f.id);
                                                      return !failedUploadIds.includes(file.transactionID);
                                                    })
      .filter(file => allUploaders.includes(file.uploadedBy));
      setPreviousSessionData(filtered);
    }
  };

  
  // âœ… Helper: render one table
  const renderTable = (data, title, fromCurrent = false) => {
    if (!data || data.length === 0) return null;

    return (
      <div className={`failed-uploads-table ${variant}`}>
        <div className="top-row">
          <div className="top-left">
            <strong>
              {title} <span className="no-of-files">{data.length}</span>
            </strong>
          </div>
          <div className="top-right">
            {fromCurrent && (
              <MotifButton
                variant="secondary"
                size="small"
                className="tiny-button"
                disabled={
                  selectedFileIds.length === 0 ||
                  selectedFileIds.every((id) => {
                    const f = data.find((f) => f.id === id);
                    return (
                      f?.attempts >= 3 ||
                      String(f?.errorCode) === "1003"
                    );
                  }) ||
                  isAnyActionInProgress
                }
                onClick={onBulkReupload}
              >
                <MotifIcon
                  src={uploadIcon}
                  style={{ width: "12px", height: "12px", marginRight: "6px" }}
                  title="Reupload"
                />
                Re-upload all
              </MotifButton>
            )}
            <MotifButton
              variant="secondary"
              size="small"
              className="tiny-button"
              disabled={
                fromCurrent
                  ? selectedFileIds.length === 0 ||
                    currentDeleteLoading ||
                    isAnyActionInProgress
                  : selectedFileIdData.length === 0 || isDeleteInProgress
              }
              onClick={async () => {
                if (fromCurrent) {
                  setCurrentDeleteLoading(true);
                  setDeleteLoad("all");
                  disableCloseButton(true);
                  if (currentDeleteTimer) clearTimeout(currentDeleteTimer);
                  const timer = setTimeout(() => {
                    setCurrentDeleteLoading(false);
                    disableCloseButton(false);
                  }, 15000);
                  setCurrentDeleteTimer(timer);
                  try {
                    await onBulkDelete("all");
                  } catch (e) {
                    // handle error if needed
                  } finally {
                    clearTimeout(timer);
                    setCurrentDeleteLoading(false);
                    disableCloseButton(false);
                    setDeleteLoad(null);
                  }
                } else {
                  setDeleteLoad("all");
                  handleDeleteAllAPI();
                }
              }}
            >
              <MotifIcon
                src={deleteIcon}
                style={{ width: "12px", height: "12px" }}
                title="Delete all"
              />
              Delete all
            </MotifButton>
            <div style={{ borderLeft: '1px solid #C3C3CB', height: '20px'}} />
            {title === "Current Session" && (
              <span onClick={() => {
                setCurrentSessionFilterOpen(!currentSessionFilterOpen);
              }} style={{ cursor: 'pointer' }} className='file-filter-icon'><MotifIcon  src={IconoirSort} style={{ height: 21, verticalAlign: 'middle' }} /></span>
            )}
            {title === "Previous Session" && (
              <span onClick={() => {
                setPreviousSessionFilterOpen(!previousSessionFilterOpen);
              }} style={{ cursor: 'pointer' }} className='file-filter-icon'><MotifIcon src={IconoirFilterList} style={{ height: 11, verticalAlign: 'middle' }} /></span>
            )}
          </div>
        </div>
        {currentSessionFilterOpen && title === "Current Session" && (
                    <MotifMenu className="failed-file-filter-menu" show={currentSessionFilterOpen && title === "Current Session"} onClose={() => handleCurrentSessionClose()}
                    >
                      <div className='file-filter-menu__title-two'>Sort by</div>
                                        <div className='file-filter-menu__subtitle-two'>Date & Time</div>
                                        <div
                                            onClick={() => {
                                              // Sort failedUploads by createdDate (newest first)
                                              failedUploads.sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate));

                                              setOnClickNewest(true);
                                              setOnClickOldest(false);
                                              setOnClickAtoZ(false);
                                              setOnClickZtoA(false);
                                              // If you use filteredData directly, update its source or add a sort state
                                            }}
                                            className='file-filter-menu__sort-option-container'
                                            style={{ background: onClickNewest ? '#E6E6E9' : '' }}
                                            >
                                            <img
                                            src={onClickNewest ? SortUpDark : SortUpLight}
                                            className={onClickNewest ? '': 'file-filter-menu__sortup-icon-light'}
                                            style={{ marginRight: 6, verticalAlign: 'middle' }}
                                            />
                                            <span className='file-filter-menu__sort-option'>Newest on top</span>
                                            {onClickNewest && <MotifIcon src={IconoirCheckIcon} style={{ marginLeft: 8, verticalAlign: 'middle' }} />}
                                            </div>
                                             <div
                                                 //checked={true} // Replace with your sort state logic
                                                 onClick={() => {
                                                   // Sort failedUploads by createdDate (oldest first)
                                                  failedUploads.sort((a, b) => new Date(a.createdDate) - new Date(b.createdDate));

                                                   // If you use filteredData directly, update its source or add a sort state
                                                   setOnClickOldest(true);
                                                    setOnClickNewest(false);
                                                    setOnClickAtoZ(false);
                                                    setOnClickZtoA(false);
                                                  }}
                                                  className='file-filter-menu__sort-option-container'
                                                   style={{ background: onClickOldest ? '#E6E6E9' : '' }}
                                                 >
                                                   <img
                                                  src={ onClickOldest ? SortDownDark : SortDownLight} style={{ marginRight: 6, verticalAlign: 'middle' }} />
                                            <span className='file-filter-menu__sort-option'>Oldest on top</span>
                                            {onClickOldest && <MotifIcon src={IconoirCheckIcon} style={{ marginLeft: 8, verticalAlign: 'middle' }} />}
                                                 </div>
                                   <div className='file-filter-menu__subtitle-three'>Alphanumeric</div>
                                   <div
                                    onClick={() => {
                                    // Sort filteredData A to Z
                                    failedUploads.sort((a, b) => a.fileName.localeCompare(b.fileName));
                                  
                                    // setFilteredData(sorted);
                                    // If you use filteredData directly, update its source or add a sort state
                                    setOnClickAtoZ(true);
                                    setOnClickZtoA(false);
                                    setOnClickOldest(false);
                                    setOnClickNewest(false);
                                  }}
                                  className='file-filter-menu__sort-option-container'
                                   style={{ background: onClickAtoZ ? '#E6E6E9' : '' }}
                               >
                                   <img
                                  src={ onClickAtoZ ? SortUpDark : SortUpLight} style={{ marginRight: 6, verticalAlign: 'middle' }} />
                              <span className='file-filter-menu__sort-option'>A to Z</span>
                              {onClickAtoZ && <MotifIcon src={IconoirCheckIcon} style={{ marginLeft: 8, verticalAlign: 'middle' }} />}
                               </div>
                               <div
                                 onClick={() => {
                                   // Sort filteredData Z to A
                                  
                                    failedUploads.sort((a, b) => b.fileName.localeCompare(a.fileName));
                                   
                                     setOnClickZtoA(true);
                                     setOnClickAtoZ(false);
                                      setOnClickOldest(false);
                                      setOnClickNewest(false);
                                   }}
                                   className='file-filter-menu__sort-option-container'
                                   style={{ background: onClickZtoA ? '#E6E6E9' : '' }}
                               ><img
                                src={onClickZtoA ? SortDownDark : SortDownLight} style={{ marginRight: 6, verticalAlign: 'middle' }} />
                              <span className='file-filter-menu__sort-option'>Z to A</span>
                            {onClickZtoA && <MotifIcon src={IconoirCheckIcon} style={{ marginLeft: 8, verticalAlign: 'middle' }} />}
                               </div>
                           </MotifMenu>) }
                           {previousSessionFilterOpen && title === "Previous Session" && (
                    <MotifMenu className="failed-file-filter-menu" show={previousSessionFilterOpen && title === "Previous Session"} onClose={() => handlePreviousSessionClose()}
                    >
                      <div className='failed-file-filter-menu__title-one'>Filter</div>
                                        <div className='failed-file-filter-menu__subtitle-one'>Uploaded by</div>
                                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
                                        <MotifCheckbox
                                          id={`uploader-select-all`}
                                          label={""}
                                          checked={Array.isArray(selectedUploader) ? selectedUploader.length === Array.from(new Set(((afterDeleteLoadData || failedUploadData || []).filter(file => {
                                                      // Exclude files whose transactionID matches any id in failedUploads
                                                      const failedUploadIds = (failedUploads || []).map(f => f.batchStatus === "Processing" ? f.transactionID : f.id);
                                                      return !failedUploadIds.includes(file.transactionID);
                                                    })).map(file => file.uploadedBy))).length : false}
                                          onChange={() => {handleToggleSelectAllUploaders(selectedUploader)  }}
                                          style={{ marginRight: 8 }}
                                        />
                                        <span style={{ fontSize: 14 }}>Select All</span>
                                        </div>
                                        <hr className='failed-file-filter-menu__divider-one' />
                                        {Array.from(new Set(((afterDeleteLoadData || failedUploadData || []).filter(file => {
                                                      // Exclude files whose transactionID matches any id in failedUploads
                                                      const failedUploadIds = (failedUploads || []).map(f => f.batchStatus === "Processing" ? f.transactionID : f.id);
                                                      return !failedUploadIds.includes(file.transactionID);
                                                    })).map(file => file.uploadedBy))).map((uploader) => (
                                          <div key={uploader} style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
                                            <MotifCheckbox
                                              id={`uploader-${uploader}`}
                                              label={""}
                                              checked={Array.isArray(selectedUploader) ? selectedUploader.includes(uploader) : false}
                                              onChange={() => {
                                                let updatedUploader = [];
                                                if (Array.isArray(selectedUploader)) {
                                                  if (selectedUploader.includes(uploader)) {
                                                    updatedUploader = selectedUploader.filter(item => item !== uploader);
                                                  } else {
                                                    updatedUploader = [...selectedUploader, uploader];
                                                  }
                                                } else {
                                                  updatedUploader = [uploader];
                                                }
                                                setSelectedUploader(updatedUploader);
                                                if(updatedUploader.length === 0) {
                                                  setPreviousSessionData((afterDeleteLoadData || failedUploadData || [])
                                                .filter(file => {
                                                      // Exclude files whose transactionID matches any id in failedUploads
                                                      const failedUploadIds = (failedUploads || []).map(f => f.batchStatus === "Processing" ? f.transactionID : f.id);
                                                      return !failedUploadIds.includes(file.transactionID);
                                                    }));
                                                } else {
                                                  const filtered = (afterDeleteLoadData || failedUploadData || [])
                                                  .filter(file => {
                                                      // Exclude files whose transactionID matches any id in failedUploads
                                                      const failedUploadIds = (failedUploads || []).map(f => f.batchStatus === "Processing" ? f.transactionID : f.id);
                                                      return !failedUploadIds.includes(file.transactionID);
                                                    })
                                                    .filter((file) => updatedUploader.includes(file.uploadedBy));
                                                  setPreviousSessionData(filtered);
                                                }
                                              }}
                                              style={{ marginRight: 8 }}
                                            />
                                            <span style={{ fontSize: 14 }}>{getUploadedByFormat(uploader)}</span>
                                          </div>
                                        ))}
                                        <hr className='failed-file-filter-menu__divider-two' />
                      <div className='failed-file-filter-menu__title-two'>Sort by</div>
                                        <div className='failed-file-filter-menu__subtitle-two'>Date & Time</div>
                                        <div
                                            onClick={() => {
                                              // Sort previousSessionData by createdDate (newest first)
                                              const sorted = [...previousSessionData].sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate));
                                              setPreviousSessionData(sorted);
                                              setOnClickNewest(true);
                                              setOnClickOldest(false);
                                              setOnClickAtoZ(false);
                                              setOnClickZtoA(false);
                                              // If you use filteredData directly, update its source or add a sort state
                                            }}
                                            className='failed-file-filter-menu__sort-option-container'
                                            style={{ background: onClickNewest ? '#E6E6E9' : '' }}
                                            >
                                            <img
                                            src={onClickNewest ? SortUpDark : SortUpLight}
                                            className={onClickNewest ? '': 'failed-file-filter-menu__sortup-icon-light'}
                                            style={{ marginRight: 6, verticalAlign: 'middle' }}
                                            />
                                            <span className='failed-file-filter-menu__sort-option'>Newest on top</span>
                                            {onClickNewest && <MotifIcon src={IconoirCheckIcon} style={{ marginLeft: 8, verticalAlign: 'middle' }} />}
                                            </div>
                                             <div
                                                 onClick={() => {
                                                   // Sort previousSessionData by createdDate (oldest first)
                                                   const sorted = [...previousSessionData].sort((a, b) => new Date(a.createdDate) - new Date(b.createdDate));
                                                   setPreviousSessionData(sorted);
                                                   // If you use filteredData directly, update its source or add a sort state
                                                   setOnClickOldest(true);
                                                    setOnClickNewest(false);
                                                    setOnClickAtoZ(false);
                                                    setOnClickZtoA(false);
                                                  }}
                                                  className='failed-file-filter-menu__sort-option-container'
                                                   style={{ background: onClickOldest ? '#E6E6E9' : '' }}
                                                 >
                                                   <img
                                                  src={ onClickOldest ? SortDownDark : SortDownLight} style={{ marginRight: 6, verticalAlign: 'middle' }} />
                                            <span className='failed-file-filter-menu__sort-option'>Oldest on top</span>
                                            {onClickOldest && <MotifIcon src={IconoirCheckIcon} style={{ marginLeft: 8, verticalAlign: 'middle' }} />}
                                                 </div>
                                   <div className='failed-file-filter-menu__subtitle-three'>Alphanumeric</div>
                                   <div
                                    onClick={() => {
                                    // Sort filteredData A to Z
                                    const sorted = [...previousSessionData].sort((a, b) => a.uploadFileName.localeCompare(b.uploadFileName));
                                  setPreviousSessionData(sorted);
                                    setOnClickAtoZ(true);
                                    setOnClickZtoA(false);
                                    setOnClickNewest(false);
                                    setOnClickOldest(false);
                                  }}
                                  className='failed-file-filter-menu__sort-option-container'
                                   style={{ background: onClickAtoZ ? '#E6E6E9' : '' }}
                               >
                                   <img
                                  src={ onClickAtoZ ? SortUpDark : SortUpLight} style={{ marginRight: 6, verticalAlign: 'middle' }} />
                              <span className='failed-file-filter-menu__sort-option'>A to Z</span>
                              {onClickAtoZ && <MotifIcon src={IconoirCheckIcon} style={{ marginLeft: 8, verticalAlign: 'middle' }} />}
                               </div>
                               <div
                                 onClick={() => {
                                   // Sort filteredData Z to A
                                  const sorted = [...previousSessionData].sort((a, b) => b.uploadFileName.localeCompare(a.uploadFileName));
                                  setPreviousSessionData(sorted);
                                     setOnClickZtoA(true);
                                     setOnClickAtoZ(false);
                                     setOnClickOldest(false);
                                     setOnClickNewest(false);
                                   }}
                                   className='failed-file-filter-menu__sort-option-container'
                                   style={{ background: onClickZtoA ? '#E6E6E9' : '' }}
                               ><img
                                src={onClickZtoA ? SortDownDark : SortDownLight} style={{ marginRight: 6, verticalAlign: 'middle' }} />
                              <span className='failed-file-filter-menu__sort-option'>Z to A</span>
                            {onClickZtoA && <MotifIcon src={IconoirCheckIcon} style={{ marginLeft: 8, verticalAlign: 'middle' }} />}
                               </div>
                           </MotifMenu>) }

        <div className="table-header">
          <MotifCheckbox
            id={`select-all-${fromCurrent ? "current" : "previous"}`}
            key={`select-all-${fromCurrent ? "current" : "previous"}-${
              fromCurrent
                ? data.length > 0 && data.every((f) => selectedFileIds.includes(f.id))
                : data.length > 0 && data.every((f) => selectedFileIdData.includes(f.errorId))
            }`}
            disabled={fromCurrent ? isAnyActionInProgress : isDeleteInProgress}
            onChange={() =>
              fromCurrent
                ? onToggleSelectAll()
                : onToggleSelectAllData(data)
            }
            checked={
              fromCurrent
                ? data.length > 0 &&
                data.every((f) => selectedFileIds.includes(f.id))
                : data.length > 0 &&
                data.every((f) => selectedFileIdData.includes(f.errorId))
            }
          />
          <span className="header-cell">File name</span>
          <span className="header-cell">Reason for failure</span>
          <span className="header-cell">Actions</span>
        </div>

        {data.map((file) => {
          const reasonText =
            file.customErrorMessage ||
            file.message ||
            file.reasonPhrase ||
            file.reason ||
            "Unknown error";

            // Disable re-upload for corrupt files or errorCode 1003
            const isReuploadBlocked = String(file.errorCode) === "1003";

            // Check if controlId is null for current file
            const isControlIdNull =
            fromCurrent
              ? file.controlId === null
              : file.controlId === null;

            return (
            <div key={file.id || file.errorId} className="table-row">
              <MotifCheckbox
              id={`failed-upload-${file.id || file.errorId}`}
              key={`failed-upload-${file.id || file.errorId}-${
                fromCurrent
                  ? selectedFileIds.includes(file.id)
                  : selectedFileIdData.includes(file.errorId)
              }`}
              value={file.id || file.errorId}
              disabled={fromCurrent ? isAnyActionInProgress : isDeleteInProgress}
              checked={
                fromCurrent
                ? selectedFileIds.includes(file.id)
                : selectedFileIdData.includes(file.errorId)
              }
              onChange={() =>
                fromCurrent
                ? onToggleSelect(file.id)
                : onToggleSelectData(file.errorId)
              }
              />
              <span className="cell">
              <div style={{width:"30px"}} >
             <img src={getImagePath(file.uploadFileName || file.fileName)} alt={`${getFileTypeName(file.uploadFileName || file.fileName)} icon`} />
              </div> 
              
                 {file.uploadFileName || file.fileName}
              </span>
              <span
              className="cell"
              style={{
                display: "inline",
                width: "90%",
                textAlign: "center",
              }}
              title={reasonText}
              >
              {reasonText.length > 20
                ? reasonText.slice(0, 20) + "..."
                : reasonText}
              </span>
              <span className="cell action-buttons">
              {fromCurrent &&
                (uploadingFileId === file.id ||
                uploadingFileIds?.includes(file.id) ? (
                <SmallCircleLoader />
                ) : (
                !isControlIdNull && (
                  <button
                  className="motif-button motif-button-secondary motif-button-small"
                  onClick={() => handleReuploadClick(file.id)}
                  disabled={
                    isReuploadBlocked ||
                    data.find((f) => f.id === file.id)?.attempts >= 3 ||
                    isAnyActionInProgress
                  }
                  title={
                    data.find((f) => f.id === file.id)?.attempts >= 3
                    ? "Max reupload attempts reached"
                    : isAnyActionInProgress
                    ? "Please wait for the current action to complete"
                    : "Reupload"
                  }
                  >
                  <MotifIcon
                    src={uploadIcon}
                    style={{ width: "15px", height: "15px" }}
                    title="Reupload"
                  />
                  </button>
                )
                ))}
              {(deleteLoad === file.id ||
                file.errorId === deleteLoad) && failedDeleteLoading ? (
                <SmallCircleLoader />
              ) : (() => {
                const isDeleteDisabled = fromCurrent
                  ? currentDeleteLoading || isAnyActionInProgress
                  : isDeleteInProgress;
                return (
                <button
                className="motif-button motif-button-secondary motif-button-small"
                disabled={isDeleteDisabled}
                style={isDeleteDisabled ? { cursor: "not-allowed" } : undefined}
                title={
                  isAnyActionInProgress
                    ? "Please wait for the current action to complete"
                    : "Delete"
                }
                onClick={async () => {
                  try {
                  if (fromCurrent) {
                    setDeleteLoad(file.id);
                    failedDeleteLoading
                    ? disableCloseButton(true)
                    : disableCloseButton(false);
                    await onDelete(file.id);
                  } else {
                    setDeleteLoad(file.errorId);
                    setCurrentDeleteLoading(true);
                    let errorIdarray = [file.errorId];
                    await deleteErrorLog(
                    file.engagementIdGUID,
                    errorIdarray,
                    file.uploadedBy,
                    file.transactionID
                    ).then(() => {
                    setCurrentDeleteLoading(false);
                    setSelectedUploader([]);
                    });
                  }
                  } catch (err) {
                  setCurrentDeleteLoading(false);
                  logger.error("Failed to delete log:", err);
                  } finally {
                    setDeleteLoad(null);
                  }
                }}
                >
                   <img
                    src={require("../../common/images/trash.svg").default}
                    alt="Delete-icon"
                    style={{
                      maxWidth: "93%",
                      opacity: isDeleteDisabled ? 0.4 : 1,
                    }}
                     
                  />
                 {/* <MotifIcon
                  src={deleteIcon}
                  style={{ width: "15px", height: "15px" }}
                  title="Delete"
                />  */}
                </button>
                );
              })()}
              </span>
              <div className="failed-file-meta-row">
            <span className="file-meta-value">
              {file?.createdDate ? getDateTimeFormat(file.createdDate) + (!fromCurrent ? "," : "") : ""}
            </span>

            {!fromCurrent && (<><span className="file-meta-label">Uploaded by:</span><span className="file-meta-value">{file.uploadedBy
                    ? getUploadedByFormat(file.uploadedBy)
                    : ""}</span></>)}
                  </div>
            </div>
            );
        })}
      </div>
    );
  };

  // if (currentDeleteLoading) {
  //   return (
  //     <div style={{
  //       display: "flex",
  //       flexDirection: "column",
  //       alignItems: "center",
  //       justifyContent: "center",
  //       height: "60vh",
  //       width: "100%"
  //     }}>
  //       <div className="circle-loader" ></div>
  //       <p style={{ marginTop: 20 }}>Deleting...</p>
  //     </div>
  //   );
  // }
  // âœ… No failed uploads case
  if (
    dataReceived.length === 0 ||
    (failedUploads.length === 0 && afterDeleteLoadData != null && failedUploadData.length === 0)
  ) {
    return (
      <div className={`failed-uploads-table ${variant}`}>
        <span
          style={{
            width: "60px",
            height: "60px",
            borderRadius: "50%",
            backgroundColor: "rgba(0, 200, 83, 0.1)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginLeft: "auto",
            marginRight: "auto",
            marginTop: "5%",
          }}
        >
          <MotifIcon
            src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02LjQ2OTY3IDExLjk2OTdDNi43NjI1NiAxMS42NzY4IDcuMjM3NDQgMTEuNjc2OCA3LjUzMDMzIDExLjk2OTdMMTAgMTQuNDM5M0wxNi40Njk3IDcuOTY5NjdDMTYuNzYyNiA3LjY3Njc4IDE3LjIzNzQgNy42NzY3OCAxNy41MzAzIDcuOTY5NjdDMTcuODIzMiA4LjI2MjU2IDE3LjgyMzIgOC43Mzc0NCAxNy41MzAzIDkuMDMwMzNMMTAuNTMwMyAxNi4wMzAzQzEwLjIzNzQgMTYuMzIzMiA5Ljc2MjU2IDE2LjMyMzIgOS40Njk2NyAxNi4wMzAzTDYuNDY5NjcgMTMuMDMwM0M2LjE3Njc4IDEyLjczNzQgNi4xNzY3OCAxMi4yNjI2IDYuNDY5NjcgMTEuOTY5N1oiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTIgMi43NUM2Ljg5MTM3IDIuNzUgMi43NSA2Ljg5MTM3IDIuNzUgMTJDMi43NSAxNy4xMDg2IDYuODkxMzcgMjEuMjUgMTIgMjEuMjVDMTcuMTA4NiAyMS4yNSAyMS4yNSAxNy4xMDg2IDIxLjI1IDEyQzIxLjI1IDYuODkxMzcgMTcuMTA4NiAyLjc1IDEyIDIuNzVaTTEuMjUgMTJDMS4yNSA2LjA2Mjk0IDYuMDYyOTQgMS4yNSAxMiAxLjI1QzE3LjkzNzEgMS4yNSAyMi43NSA2LjA2Mjk0IDIyLjc1IDEyQzIyLjc1IDE3LjkzNzEgMTcuOTM3MSAyMi43NSAxMiAyMi43NUM2LjA2Mjk0IDIyLjc1IDEuMjUgMTcuOTM3MSAxLjI1IDEyWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg=="
            style={{ width: "30px", height: "30px" }}
          />
        </span>
        <p className="files-uploaded-message">
          { processingMsg ? "All files are successfully uploaded." : "All failed uploads are deleted."}
        </p>
        <p>You can continue</p>
      </div>
    );
  }

  // âœ… If showTopRow is true and we have current failed uploads â†’ show 2 tables
  if (showTopRow) {
    // collect all current session IDs
    const currentIds = failedUploads.map((f) => f.id);
    // filter previous session data â†’ exclude any record where transactionID matches current id
    if (!calculated) {
      const filtered = (afterDeleteLoadData || failedUploadData || [])
        .filter((file) => file.errorId)
        .filter((file) => !currentIds.includes(file.transactionID) && !currentIds.includes(file.errorId));
      setPreviousSessionData(filtered);
      setCalculated(true);
    }

    return (
      <>
        {failedUploads.length > 0 && renderTable(failedUploads, "Current Session", true)}
        {previousSessionData.length > 0 && renderTable(previousSessionData, "Previous Session", false)}
      </>
    );
  }
  return renderTable(
    isFromFailedUploads
      ? dataReceived
      : (afterDeleteLoadData || dataReceived).filter((file) => file.errorId),
    "Failed Uploads",
    isFromFailedUploads
  );
};